<template>
	<div class="contacts-department flex flex-space-between">
    <div class="contacts-department-image">
      <vz-icon
        :url="icon"
        size=76
        variant="gray"
        no-masked-icon
      />
    </div>
    <div class="contacts-department-wrapper">
      <div v-if="phones" class="contacts-department-data flex flex-align-items-center flex-wrap">
        <a v-for="phone in phones" :key="phone" :href="getPhoneLink(phone)" class="contacts-department-data-item mb-10">
          <vz-icon
            size=16
            no-masked-icon
            variant="primary"
            url="/svg/vz-phone.svg"
          />
          {{ phone }}
        </a>
      </div>
      <div v-if="validEmails" class="contacts-department-data flex flex-align-items-center flex-wrap">
        <a v-for="email in validEmails" :key="email" :href="getEmailLink(email)" class="contacts-department-data-item mb-10">
          <vz-icon
            size=16
            no-masked-icon
            variant="primary"
            url="/svg/vz-mail.svg"
          />
          {{ email }}
        </a>
      </div>
      <vz-button
        big
        variant="primary"
        @click="emit('click')"
      >
        {{ btnTitle }}
      </vz-button>
    </div>
	</div>
</template>

<script setup lang="ts">
import { PropType } from "vue"

const emit = defineEmits(['click'])

const props = defineProps({
	icon: {
		type: String, 
		default: ''
	},
	phones: {
		type: Array as PropType<String[]>,
		default: () => []
	},
	emails: {
		type: Array as PropType<String[]>,
		default: () => []
	},
	btnTitle: {
		type: String,
		default: ''
	}
})

const validEmails = computed(() => {
  return props.emails.filter((i) => i.indexOf('@') > 0)
})

function getEmailLink(email: string) {
  return `mailto:${email}`
}

function getPhoneLink(phone: string) {
  return `tel:${phone}`
}
</script>